/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取次banner信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.SecondBannerDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/banners/secondary`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
